document.addEventListener('alpine:init', () => {
  Alpine.data('share', () => ({
    url: '',
    text: '',
    title: '',
    clipboardSupported: false,
    shareSupported: false,
    linkCopied: false,
    error: false,
    
    init() {
      this.url = this.$el.dataset.url;
      this.text = this.$el.dataset.description;
      this.title = this.$el.dataset.title;

      // Test for share and clipboard support
      if (navigator) {
        if (typeof navigator.share !== "undefined") {
          this.shareSupported = true;
        }
        if (typeof navigator.clipboard !== "undefined") {
          this.clipboardSupported = true;
        }
      }
      
      // Watch for state changes
      this.$watch('linkCopied', (value) => {
        if (value) {
          setTimeout(() => {
            this.linkCopied = false;
          }, 5000);
        }
      });
      
      this.$watch('error', (value) => {
        if (value) {
          setTimeout(() => {
            this.error = false;
          }, 5000);
        }
      });
    },
    
    async share() {
      try {
        await navigator.share({
          url: this.url,
          text: this.text,
          title: this.title,
        });
      } catch (error) {
        switch (error.name) {
          case "AbortError":
          case "InvalidStateError":
            break;
          case "DataError":
          case "TypeError":
          case "NotAllowedError":
          default:
            if (this.clipboardSupported) {
              this.copyToClipboard();
            }
        }
      }
    },
    
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.url);
        this.linkCopied = true;
      } catch (error) {
        this.error = true;
      }
    }
  }));
});

function getSharePropsFromSeomatic(seomatic) {
  if (!seomatic?.metaTagContainer) {
    return {};
  }

  const meta = JSON.parse(seomatic.metaTagContainer);
  const title = meta["og:title"].content;
  const text = meta.description.content;
  const url = meta["og:url"].content;

  return { title, text, url };
}